
import { Component, Vue } from 'vue-property-decorator'

import type { LanguageStrings } from '@/language/types'

@Component({ name: 'MembersOnly' })
export default class extends Vue {
  t: LanguageStrings['membersOnly']
}
